/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: bbq
 * @LastEditTime: 2021-02-20 09:37:12
 * @Description: file content
 */
import getCellIdentity from './getCellIdentity';
import { config as CONFIG } from '@platform/api'
import { findParentTd } from '@platform/api';
import { executeAutoFocus } from './findNextFocusItemInTable';
import calculateNeedJumpTimes from './calculateNeedJumpTimes';

/**
 * @desc 查找上一行元素
 * @param target {dom} 事件源
 * @param ViewModel {object} 全局变量
 * @param moduleId {string} 当前区域Id
 * @param orderOfHotKey {array} 区域显示顺序配置
 */
function findDownStairsFocusItemInTable({ eventTarget, ViewModel, moduleId }) {
    // debugger;
    let parentTd = eventTarget.tagName === 'TD' ? eventTarget : findParentTd(eventTarget);
    let downStairTr = parentTd.parentElement.nextElementSibling;
    let jumpedLines = 1; //向下跳跃的行数

    if (downStairTr === null) return;

    if (downStairTr.getAttribute('tabindex') === '-1') {
        jumpedLines = calculateNeedJumpTimes(downStairTr, jumpedLines, 'down');

    }

    let cellIdentity = getCellIdentity(parentTd);

    if (!cellIdentity) {
        return console.warn('not find cell identity!');
    }

    let cellIdentityArray = cellIdentity && cellIdentity.split('-');
    let downStairsLine = Number(cellIdentityArray.pop()) + jumpedLines;

    let id = `${CONFIG.hotKeyModuleIdPrefix}-${moduleId}`;
    // let tableTr = document.querySelectorAll(`#${id} table tbody tr.u-table-row`);

    // if (downStairsLine < tableTr.length) {
    cellIdentityArray.push(downStairsLine);
    let upStairsCellIdentity = cellIdentityArray.join('-');
    ViewModel.upStairsCellIdentity = upStairsCellIdentity;

    let div = document.querySelector(`div[${upStairsCellIdentity}="${upStairsCellIdentity}"] [tabindex="0"], div[${upStairsCellIdentity}="${upStairsCellIdentity}"][tabindex="0"]`);

    executeAutoFocus({ div, ViewModel });
    // }
}

export { findDownStairsFocusItemInTable };
